// 浏览器兼容性
import "core-js/stable";
import "regenerator-runtime/runtime";
// 引入打印插件
import Print from 'vue-print-nb';
Vue.use(Print)
// 大文件上传
import uploader from "vue-simple-uploader";
Vue.use(uploader);

import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "font-awesome/css/font-awesome.min.css";

import Cookies from "js-cookie";
import lodash from "lodash";
import i18n from "./i18n"; // 国际化

import "@/styles/index.scss";

import App from "./App.vue";
import store from "./store";
import router from "./router";

// import Setting from "@/settings";
// import util from "@/libs/util.js";

import MainLayout from "@/components/main-layout";
Vue.use(MainLayout);

// 权限验证组件
import Auth from "@/components/auth";
Vue.component("Auth", Auth);

// 权限验证指令
import VAuth from "@/directives/auth";
Vue.use(VAuth);

// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme


// 前端提交监测年度 
import _localData from './libs/localData'//引用文件
Vue.prototype.localData = _localData//挂载到Vue实例上面


Vue.use(VueQuillEditor, /* { default global options } */)

// 全局指令 修改 dialog modal 

ElementUI.Dialog.props.closeOnClickModal.default = false // 弹出框关闭模式
ElementUI.Dialog.props.closeOnPressEscape.default = false// 弹出框关闭模式

Vue.use(ElementUI, {
  //size: Cookies.get("size") || "medium", // medium / small / mini
  size: Cookies.get("size") || "small",
  i18n: (key, value) => i18n.t(key, value)
});

//视频插件
import VideoPlayer from 'vue-video-player';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.config.productionTip = false;

Vue.prototype.$_ = lodash;

// 定义延迟加载时间
const delayTime = 1000;
Vue.prototype.DelayTime = delayTime;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App),
  created() { }
});
